import elementUI from 'element-ui';
import CommonService from '@/api/CommonService';
export default function initApp(Vue) {

  Vue.use(elementUI, { size: 'mini', zIndex: 100 });

  Vue.prototype.$http = function (connName, spName, usingGet = false) {
    return new CommonService(connName, spName, usingGet);
  };
  // 加载样式
  require(`./assets/scss/index.scss`);
  require(`./assets/scss/app.scss`);
}
